module.exports = __webpack_public_path__ + "img/emergencySupplies_checked.509eeb7f.png";